import routes from "routes";
import { entityType } from "utils/commons";

// Bookmarking (and the internal detail route) is only supported for
// Offerings/Quals anywhere in this app today - Business Challenges are
// viewable (they have a detail route) but not bookmarkable. Shared
// between CitationList (per-document bookmark button) and
// ChatResultActions (bulk "Bookmark all").
export const BOOKMARKABLE_TYPES = new Set([
  entityType.OFFERING_TOPIC,
  entityType.QUALIFICATION,
]);

export const DETAIL_ROUTE_BY_TYPE = {
  [entityType.OFFERING_TOPIC]: routes.OFFERING,
  [entityType.QUALIFICATION]: routes.QUALS,
  [entityType.BUSINESS_CHALLENGE]: routes.BUSINESS_CHALLENGE,
};

// Internal SPA route for a chat-result document, falling back to the
// external url the backend already provides if the type isn't one of the
// app's own detail pages.
export const documentDetailPath = doc => {
  const base = DETAIL_ROUTE_BY_TYPE[doc.type];
  return base ? `${base}/${doc.code}` : null;
};
